


































import Vue, { PropOptions } from 'vue';
import SearchResult from '@/components/util/SearchResult.vue';
import {ISelectOption as iso} from '@/class/models/typed/wild';
import ClickOutside from 'vue-click-outside';
export type IOption = iso;

export default Vue.extend({
  name: 'RichSelectBox',
  components: { SearchResult },
  props: {
    initialValues: Array as PropOptions<iso[]>,
    options: Array as PropOptions<iso[]>,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchText: '',
      excludeList: [] as iso[],
      selectList: [] as number[],
      selectorshow: false,
    };
  },
  mounted() {
    if (this.initialValues) {
      this.excludeList = [ ...this.initialValues ];
      this.selectList = [];
    } else {
      this.excludeList = [];
      this.selectList = [];
    }
  },
  directives: {
      ClickOutside,
  },
  computed: {
    OPTIONS(): iso[] {
      if (this.options) {
        return this.options.filter((v) => !this.excludeList.some((v2) => v.value === v2.value));
      } else {
        return [];
      }
    },
  },
  watch: {
    initialValues: {
      immediate: true,
      handler(val) {
        if (val) {
          this.excludeList = [ ...val ];
          this.selectList = [];
        } else {
          this.excludeList = [];
          this.selectList = [];
        }
      },
    },
  },
  methods: {
    onClickItem(value: number) {
      const clickedIndex = this.selectList.findIndex((v) => v === value);
      if (clickedIndex > -1) { // 削除
        this.selectList.splice(clickedIndex, 1);
      } else { // 追加
        this.selectList.push(value);
      }
    },
    closeSelect() {
      this.selectorshow = false;
    },
    onClickCancel() {
      this.selectorshow = false;
      this.selectList = [];
    },
    onClickAdd() {
      this.selectorshow = false;
      this.$emit('change', this.selectList);
      this.selectList = [];
    },
  },
});
